<template>
  <exception
    title="404 Error!"
    description="抱歉，你访问的页面不存在~"
  />
</template>

<script>
import Exception from '@/components/exception';

export default {
  components: {
    Exception,
  },
};
</script>
